<template lang="pug">
#modal-informacao-territorio
        el-dialog(
            width='600px',
            title='Informação Territorio',
            :visible.sync='mostrar',
            :close-on-click-modal='false',
            :before-close='fechar'
        )
            el-form(label-position='top')
                el-row(:gutter="20")
                    el-col(:span="12")
                        el-form-item
                            template(slot='label')
                                span Território
    
                            el-input(v-model='codigoTerritorio')
                    
                    el-col(:span="12")
                        el-form-item
                            template(slot='label')
                                span Fornecedor
    
                            el-input(v-model='codigoFornecedor')
                
                el-row(:gutter="20")
                    el-col(:span="12")
                        el-form-item
                            template(slot='label')
                                span Área (ha)
    
                            el-input(v-model='areaTerritorio', type='number')
    
            footer.espaco(slot='footer')
    
                BaseButton(
                    type='primary'
                ) Realizar Diagnóstico
    
</template>
    
<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ModalInformacaoTerritorio',
    components: {
        BaseButton
    },
    emits: ['atualizarDados'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            codigoTerritorio: '',
            codigoFornecedor: '',
            areaTerritorio: ''
        };
    },

    watch: {
        mostrar() {
        }
    },

    methods: {
        fechar() {
            this.id = '';
            this.numeroNotaFiscal = '';
            this.materialDescricao = '';
            this.quantidade = '';
            this.dataEmissao = '';

            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss">
footer {
    display: flex;
    justify-content: space-between;
}

.invalido {
    color: var(--danger);
}

.espaco {
    display: flex;
}

.el-date-editor.el-input {
    width: 100%;
}
</style>
